import axiosConfig from "./axiosConfig";

class PromotionService {
  async getAll() {
    try {
      const response = await axiosConfig.get("/promotion");
      return response.data || { data: [] };
    } catch (error) {
      console.error("Error fetching promotions:", error);
      return { data: [] };
    }
  }

  async create(promotion) {
    try {
      const response = await axiosConfig.post("/promotion", promotion);
      return response.data;
    } catch (error) {
      console.error("Error creating promotion:", error);
      return Promise.reject(error.response?.data || error.message);
    }
  }

  async update(id, promotion) {
    try {
      const response = await axiosConfig.patch(`/promotion/${id}`, promotion);
      return response.data;
    } catch (error) {
      console.error("Error updating promotion:", error);
      return Promise.reject(error.response?.data || error.message);
    }
  }

  async delete(id) {
    try {
      const response = await axiosConfig.delete(`/promotion/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting promotion:", error);
      return Promise.reject(error.response?.data || error.message);
    }
  }
}

const PromotionServiceInstance = new PromotionService();
export default PromotionServiceInstance;
